// src/components/coupons/Table/CouponEffectiveStatusBadge.jsx
import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const EFFECTIVE_STATUS_META = {
    active:      { color: 'success', labelEn: 'Active',        labelAr: 'نشط' },
    inactive:    { color: 'default', labelEn: 'Inactive',      labelAr: 'غير نشط' },
    not_started: { color: 'info',    labelEn: 'Not Started',   labelAr: 'لم يبدأ' },
    expired:     { color: 'error',   labelEn: 'Expired',       labelAr: 'منتهي' },
    used_up:     { color: 'warning', labelEn: 'Limit Reached', labelAr: 'استُنفد' },
};

/**
 * Resolve a coupon's display status.
 * Always prefer the server-supplied `effective_status`; fall back to
 * client-side derivation only for legacy responses that don't include it.
 */
export const resolveEffectiveStatus = (coupon) => {
    if (coupon?.effective_status && EFFECTIVE_STATUS_META[coupon.effective_status]) {
        return coupon.effective_status;
    }
    if (coupon?.is_active === false) return 'inactive';
    if (coupon?.ends_at && dayjs(coupon.ends_at).isBefore(dayjs())) return 'expired';
    if (coupon?.starts_at && dayjs(coupon.starts_at).isAfter(dayjs())) return 'not_started';
    if (coupon?.usage_limit && coupon?.redemption_count >= coupon.usage_limit) return 'used_up';
    return 'active';
};

const CouponEffectiveStatusBadge = ({ coupon, status: statusProp, sx }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const status = statusProp || resolveEffectiveStatus(coupon);
    const meta = EFFECTIVE_STATUS_META[status] || EFFECTIVE_STATUS_META.active;

    return (
        <Chip
            label={isArabic ? meta.labelAr : meta.labelEn}
            size="small"
            color={meta.color}
            variant="tonal"
            sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '90px', ...sx }}
        />
    );
};

export default CouponEffectiveStatusBadge;
